import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaPatternFacet extends XmlSchemaFacet {}
